import { motion } from "framer-motion";

export default function ProjectCard({ project }) {
  return (
    <motion.div
      variants={{
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0 }
      }}
      whileHover={{
        rotateY: 10,
        rotateX: -5,
        scale: 1.05,
        z: 50,
        transition: { duration: 0.3 }
      }}
      className="card"
    >
      <img src={project.src} alt={project.title} loading="lazy" />
      <div className="card-content">
        <h3>{project.title}</h3>
        <div className="stack">
          {project.stack.split(", ").map(tech => (
            <span key={tech} className="tag">{tech}</span>
          ))}
        </div>
        <p>{project.description}</p>
        <div style={{ display: 'flex', gap: '1rem' }}>
          <a href={project.live} target="_blank" rel="noreferrer" className="btn-primary" style={{ padding: '0.5rem 1rem', fontSize: '0.9rem' }}>Live Demo</a>
          <a href={project.github} target="_blank" rel="noreferrer" className="btn-secondary" style={{ padding: '0.5rem 1rem', fontSize: '0.9rem' }}>Source Code</a>
        </div>
      </div>
    </motion.div>
  );
}
